import config from "./config";
import { isIEBrowser, isSafariBrowser } from "./";

export const send = (action, state) => {
  if (isIEBrowser() || isSafariBrowser()) {
    return;
  }
  const broadcastChannel = new BroadcastChannel(config.broadcastChannelName);
  broadcastChannel.postMessage({ action, state });
};

export const subscribe = (callback) => {
  if (isIEBrowser() || isSafariBrowser()) {
    return;
  }
  const broadcastChannel = new BroadcastChannel(config.broadcastChannelName);
  broadcastChannel.onmessage = callback;
};

export const close = () => {
  if (isIEBrowser() || isSafariBrowser()) {
    return;
  }
  const broadcastChannel = new BroadcastChannel(config.broadcastChannelName);
  broadcastChannel.close();
};
